import React from 'react';

const Results = props => {
	const {
		picRef,
		score,
		title,
		rqDetail,
		explanation,
		disclaimer1,
		disclaimer2
	} = props;
	return (
		<section className="results-section">
			<h2>Results</h2>
			<div className="results-section__card">
				<img src={picRef} alt="" />
			</div>
			<div className="results-section__card">
				<h4 className="results-section__card-score">
					You have a score of {score}
				</h4>
				<h3 className="results-section__card-title">{title}</h3>
				<p className="results-section__card-detail">{rqDetail}</p>
				{/*explanation, in a couple cases, contains multiple paragraphs. 
				this is the only case on this page where class declarations are contained elsewhere */}
				{explanation}
			</div>
			<p className="results-section__disclaimer">{disclaimer1}</p>
			<p className="results-section__disclaimer">{disclaimer2}</p>
		</section>
	);
};

export default Results;



// WEBPACK FOOTER //
// ./src/components/results/Results.js